import type { PlaygroundNodeData } from "@/utils/playground/workflowToNodes";

import React from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Icon } from "@iconify/react";

import { useTheme } from "@/hooks/use-theme";

import { StatusBadge } from "./StatusBadge";

const PlaygroundOutputNode: React.FC<NodeProps> = ({ data, selected }) => {
  const nodeData = data as PlaygroundNodeData;
  const { isDark } = useTheme();

  return (
    <div
      className={`
        px-4 py-3 rounded-xl border-2 min-w-[180px] transition-all duration-200
        ${selected ? "ring-2 ring-green-400 ring-offset-2" : ""}
        ${isDark ? "bg-default-100 border-green-500/50" : "bg-white border-green-300"}
        shadow-md hover:shadow-lg
      `}
    >
      <div className="flex items-center gap-3">
        <div
          className={`
            rounded-full w-10 h-10 flex items-center justify-center shrink-0
            ${isDark ? "bg-green-500/20" : "bg-green-50"}
          `}
        >
          <Icon
            className={`w-5 h-5 ${isDark ? "text-green-400" : "text-green-600"}`}
            icon="solar:check-circle-linear"
          />
        </div>
        <div className="min-w-0">
          <div
            className={`text-sm font-semibold ${isDark ? "text-default-800" : "text-green-900"}`}
          >
            {nodeData.label}
          </div>
        </div>
      </div>

      {nodeData.status && (
        <div className="absolute -top-2 -right-2">
          <StatusBadge isCurrentStep={nodeData.isCurrentStep || false} status={nodeData.status} />
        </div>
      )}

      <Handle
        className="!w-3 !h-3 !bg-green-500 !border-2 !border-white"
        position={Position.Left}
        type="target"
      />
    </div>
  );
};

export default PlaygroundOutputNode;
